import { Dialog, DialogActions, DialogContent } from '@material-ui/core';
import React from 'react';
import PropTypes from 'prop-types';

const ColorLedger = ({ handleOnClose, colorLegend, isDpsScreen }) => {
    const styleColorBox = {
        width: '60px',
        height: '20px',
        border: '1px solid black'
    };

    const styleMessage = {
        fontSize: '14px',
        color: 'black'
    };

    return (
        <Dialog
            open
            onClose={handleOnClose}
            scroll="paper"
            maxWidth="lg"
        >
            <DialogContent>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(1, 18% 80%)', gap: isDpsScreen ? '20px 10px' : '20px 29px', alignItems: 'center' }}>
                    {colorLegend.map(({ id, color, description }) => (
                        <React.Fragment key={id}>
                            <div style={{ ...styleColorBox, backgroundColor: color }} />
                            <div style={styleMessage}>{description}</div>
                        </React.Fragment>
                    ))}
                </div>
            </DialogContent>
            <DialogActions />
        </Dialog>
    );
};

export default ColorLedger;

ColorLedger.propTypes = {
    colorLegend: PropTypes.arrayOf(PropTypes.shape({
        color: PropTypes.string,
        description: PropTypes.string
    })),
    handleOnClose: PropTypes.func,
    isDpsScreen: PropTypes.bool
};
